import { EmailIcon } from '@/components/icons'
import {
  ROUTE_LOGIN,
  ROUTE_MAIN,
  ROUTE_PLAYERS,
  ROUTE_PRIVACY_POLICY,
  ROUTE_SIGNUP,
  ROUTE_TERMS,
} from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import { Link } from 'react-router-dom'

interface Props {
  onToggleIframe: () => void
}

export const Footer = ({ onToggleIframe }: Props) => {
  const { token } = useAppSelector(authSelector)

  return (
    <div className="bg-darkNavy">
      <div className="container mx-auto text-white">
        <div className="grid grid-cols-1 sm:grid-cols-4 px-4 py-6 lg:px-8 lg:py-20 justify-items-center">
          <div className="flex flex-col h-full justify-between min-w-[186px]">
            <Link to={`${ROUTE_MAIN}?r=0`}>
              <img src="/img/dupr_light.svg" alt="Dreamland Universal Pickleball Ratings" className="w-36" />
            </Link>
            <p className="font-semibold mt-6 text-xl">Contact</p>
            <div className="flex gap-x-1 items-center">
              <EmailIcon height={16} width={16} />
              <a href="mailto:support@mydupr.com" className="text-sm font-medium">
                support@mydupr.com
              </a>
            </div>
            {/* <div className="flex gap-x-1 items-center">
              <ChatIcon height={16} width={16} />
              <a href={SMS_PHONE_NUMBER} className="text-sm font-medium">
                TEXT:{PHONE_NUMBER}
              </a>
            </div> */}
          </div>

          <div className="flex flex-col h-full justify-between min-w-[186px] [&>*]:py-1.5 [&>*]:px-4 font-medium">
            {!token && (
              <>
                <Link to={ROUTE_SIGNUP}>Sign Up</Link>
                <Link to={ROUTE_LOGIN}>Log In</Link>
              </>
            )}
            <Link to={ROUTE_PLAYERS}>Search Players</Link>
            <div className="cursor-pointer" onClick={onToggleIframe}>
              Run Events
            </div>
            <a href="https://www.blog.mydupr.com/collegiate" target="_blank">
              Collegiate Pickleball
            </a>
            <a href="https://www.blog.mydupr.com/post/dupr-flex-leagues" target="_blank">
              Flex League
            </a>
          </div>

          <div className="flex flex-col h-full min-w-[186px]">
            <a href="https://www.support.mydupr.com/" className="py-1.5 px-4 font-medium" target="_blank">
              How It Works
            </a>
            <a
              href="/logokits/DUPR_Logo_Kit.zip"
              className="py-1.5 px-4 font-medium"
              download="DUPR-Logo-Kit.zip"
              type="application/zip"
            >
              Logo Kit
            </a>
            <Link to={ROUTE_TERMS} className="py-1.5 px-4 font-medium">
              Terms of Use
            </Link>
            <Link to={ROUTE_PRIVACY_POLICY} className="py-1.5 px-4 font-medium">
              Privacy Policy
            </Link>
            <a
              href="https://www.blog.mydupr.com/post/dupr-community-guidelines"
              target="_blank"
              className="py-1.5 px-4 font-medium"
            >
              Collegiate Pickleball
            </a>
          </div>

          <div className="flex flex-col h-full min-w-[186px]">
            <button
              className="max-w-[176px]"
              onClick={() => {
                window.open('https://apps.apple.com/us/app/dupr/id1567932355')
              }}
            >
              <img src="img/app_store_logo.svg" alt="DUPR iOS App" className="p-2 w-44 object-cover" />
            </button>
            <button
              className="max-w-[176px]"
              onClick={() => {
                window.open('https://play.google.com/store/apps/details?id=gg.dupr&hl=en&gl=US&pli=1')
              }}
            >
              <img src="img/google_play_logo.png" alt="DUPR iOS App" className="p-2 w-44 object-cover" />
            </button>
            <div className="flex mt-4 justify-between px-2 w-44 [&>*]:w-5 [&>*]:h-5 [&>*]:cursor-pointer [&>*]:object-cover">
              <img
                onClick={() => {
                  window.open('https://www.facebook.com/DUPRPB')
                }}
                src="img/social-links/facebook.svg"
                alt="DUPR Facebook Page"
              />
              <img
                onClick={() => {
                  window.open('https://www.instagram.com/duprpb/')
                }}
                src="img/social-links/instagram.svg"
                alt="DUPR Instagram Page"
              />
              <img
                onClick={() => {
                  window.open('https://www.linkedin.com/company/dupr/')
                }}
                src="img/social-links/linkedin.svg"
                alt="DUPR LinkedIn Page"
              />
              <img
                onClick={() => {
                  window.open('https://twitter.com/DUPRpb')
                }}
                src="img/social-links/twitter.svg"
                alt="DUPR Twitter Page"
              />
              <img
                onClick={() => {
                  window.open('https://www.youtube.com/c/DUPRPB')
                }}
                src="img/social-links/youtube.svg"
                alt="DUPR YouTube Page"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
